'use client';
import React, { forwardRef } from 'react';
import InputUnit from './InputUnit.mjs';
import { INPUT_SHAPE } from '../../constants/input.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

/**
 * Line 형태의 수치 입력 Input
 * - 숫자만 입력할 수 있습니다.
 * - input 우측에 단위(unit)를 표시합니다.
 * - formatType, maxDecimalDigits 값에 따라 inputMode 어트리뷰트를 설정합니다.
 *     - `formatType === 'none'` ➝ `text`
 *     - `formatType !== 'none' && maxDecimalDigits === 0` ➝ `numeric`
 *     - `formatType !== 'none' && maxDecimalDigits > 0` ➝ `decimal`
 */
const InputLineUnit = /*#__PURE__*/forwardRef((props, ref) => {
  useApplyLogging('InputLineUnit');
  return /*#__PURE__*/React.createElement(InputUnit, {
    ref: ref,
    shape: INPUT_SHAPE.LINE,
    ...props
  });
});
InputLineUnit.displayName = 'InputLineUnit';

export { InputLineUnit as default };
